import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BYPASS_ROUTE_GUARD } from '@domgen/dgx-fe-common';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { Observable, of } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { CheckoutFacade } from '../../+state/checkout.facade';

export const hasCompletedItemsGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const bypassRouteGuard = inject(BYPASS_ROUTE_GUARD);
  const checkoutFacade = inject(CheckoutFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasCompletedItemsGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  if (bypassRouteGuard) {
    loggingService.debug('hasCompletedItemsGuard', 'Success');
    return of(true);
  }

  return checkoutFacade.hasCompletedItems$.pipe(
    first(),
    tap((canActivate: boolean) => {
      if (!canActivate) {
        loggingService.debug('hasCompletedItemsGuard', 'Redirect', redirectTo);

        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });

        return;
      }

      loggingService.debug('hasCompletedItemsGuard', 'Success');
    })
  );
};
